export const JoinRenewCta = {
  Join: 'join',
  Renew: 'renew',
  None: 'none',
};

/**
 * @param {string | number | null | undefined} dateRaw
 * @returns {number} epoch milliseconds, or NaN if missing/unparseable
 */
export function parseDateMs(dateRaw) {
  if (dateRaw == null) {
    return NaN;
  }
  const s = String(dateRaw).trim();
  if (!s) {
    return NaN;
  }
  if (typeof dateRaw === 'number' && Number.isFinite(dateRaw)) {
    const n = dateRaw < 1e12 ? dateRaw * 1000 : dateRaw;
    return Number.isFinite(n) ? n : NaN;
  }

  const ts = Date.parse(s);
  if (!Number.isNaN(ts)) {
    return ts;
  }

  const mdy = s.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
  );
  if (mdy) {
    const month = parseInt(mdy[1], 10) - 1;
    const day = parseInt(mdy[2], 10);
    let year = parseInt(mdy[3], 10);
    if (year < 100) {
      year += year >= 70 ? 1900 : 2000;
    }
    const hh = mdy[4] != null ? parseInt(mdy[4], 10) : 0;
    const mm = mdy[5] != null ? parseInt(mdy[5], 10) : 0;
    const ss = mdy[6] != null ? parseInt(mdy[6], 10) : 0;
    const mdyTs = new Date(year, month, day, hh, mm, ss).getTime();
    if (!Number.isNaN(mdyTs)) {
      return mdyTs;
    }
  }

  return NaN;
}

/**
 * Determines which membership CTA the header should show.
 *
 *  - no membership (no membershipDetails, or type isn't "Member") -> Join Now
 *  - isAvailableForOnlineRenewal is authoritative when it's true - mirrors
 *    nfib.com's own header logic (`$showRenew = $customerInfo['isAvailableForOnlineRenewal']`),
 *    which trusts this backend-computed flag over any local date math.
 *    A missing flag is treated the same as false: never show Renew from it.
 *  - now in [originalJoinDate, renewalDate) -> no button (member in good standing)
 *  - otherwise (including missing/unparseable dates) -> Join Now
 *
 * @param {{ type?: string, originalJoinDate?: string, renewalDate?: string, terminationDate?: string, isAvailableForOnlineRenewal?: boolean } | null | undefined} membershipDetails
 * @returns {'join' | 'renew' | 'none'}
 */
export function computeJoinRenewCta(membershipDetails) {
  if (!membershipDetails || membershipDetails.type !== 'Member') {
    return JoinRenewCta.Join;
  }

  if (membershipDetails.isAvailableForOnlineRenewal === true) {
    return JoinRenewCta.Renew;
  }

  const originalJoinMs = parseDateMs(membershipDetails.originalJoinDate);
  const renewalMs = parseDateMs(membershipDetails.renewalDate);

  if (Number.isNaN(originalJoinMs) || Number.isNaN(renewalMs)) {
    return JoinRenewCta.Join;
  }

  const now = Date.now();

  if (now >= originalJoinMs && now < renewalMs) {
    return JoinRenewCta.None;
  }

  return JoinRenewCta.Join;
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/NfibSiteChrome/nfibJoinRenewUtils.js